import { ChangeEvent, MouseEvent, KeyboardEvent } from 'react';
import { IInputWithButtonProps } from './IInputWithButtonProps';
import './InputWithButton.css';

export enum EButtonStyle {
    PRIMARY = 'primary',
    LIGHT = 'light',
    DANGER = 'danger',
    SECONDARY = 'secondary',
    GHOST = 'ghost',
}

interface ITextInputWithButtonProps extends IInputWithButtonProps {
    inputRef?: React.RefObject<HTMLInputElement>;
    onClick: (e: MouseEvent | KeyboardEvent<HTMLInputElement>) => void;
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const InputWithButton = (props: ITextInputWithButtonProps) => {
    const wrapperClass = `${props.wrapperClassName} ${
        props.withBackground ? 'input-with-button-wrapper' : ''
    }`;
    const buttonStyle = props.buttonStyle || EButtonStyle.PRIMARY;

    const onKeyDownHandler = (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            props.onClick(event);
        }
    };

    return (
        <div className={wrapperClass}>
            <div className={'input-with-button-inner-wrapper'}>
                {props.prefixIcon && <div>{props.prefixIcon}</div>}

                <input
                    data-testid={'input-with-button-input'}
                    value={props.inputValue}
                    placeholder={props.placeholder}
                    onChange={props.onChange}
                    onKeyDown={onKeyDownHandler}
                    className={'input-with-button-input'}
                    disabled={props.inputDisabled}
                    name={props.inputName}
                    ref={props.inputRef}
                />

                {props.suffixIcon && (
                    <div className='mr-3 ml-auto'>{props.suffixIcon}</div>
                )}

                <button
                    type='button'
                    data-testid={'input-with-button-button'}
                    className={`susy-button susy-button-${buttonStyle} susy-button-sm mr-1 input-with-button-button`}
                    onClick={props.onClick}
                    disabled={props.buttonDisabled}
                >
                    {props.buttonText}
                </button>
            </div>
        </div>
    );
};
